import styled from 'styled-components'

import { BaseBadgeStyles, type IBaseBadgeProps } from './BaseBadgeStyles'
import { type StatusBadgeStatus } from '../StatusBadge'

interface IStatusBadgeStyledProps extends IBaseBadgeProps {
  type: StatusBadgeStatus
}

export const StatusBadgeStyled = styled.span<IStatusBadgeStyledProps>`
  ${BaseBadgeStyles}

  color: ${(props) => props.theme.colors.badge[props.type].content};

  background: ${(props) => props.theme.colors.badge[props.type].background};
`
